import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CONSTANTS } from "../../CONSTANTS";

const StyledTextField = styled(TextField)({
    '& .MuiFormLabel-root.MuiInputLabel-shrink': {
      color: CONSTANTS.COLORS.LABEL_GREY,
      fontSize: '12px',
    },
    '& .MuiInputBase-input': {
      color: CONSTANTS.COLORS.TEXT_GRAY,
    },
    '& .MuiInputBase-root': {
      maxHeight: '40px',
    }
  });

  export default StyledTextField;